import { Card, Col, PageHeader, Row } from "antd";
import {
  SafetyCertificateOutlined,
  FileProtectOutlined,
  SolutionOutlined,
  LineChartOutlined,
  FundOutlined,
  IdcardOutlined,
  TeamOutlined,
  DollarOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import React, { Component } from "react";

const OPCIONES = [
  {
    key: "listaRaya",
    titulo: "Lista de Raya",
    descripcion:
      "La lista de raya de varias prenóminas en un solo archivo: una hoja por periodo, concentrado por periodo y por empleado, y las hojas de bajas y vacaciones.",
    icono: <SolutionOutlined />,
    color: "#00BFD6",
    ruta: "listaRaya",
    disabled: false,
  },
  {
    key: "comparativoPeriodos",
    titulo: "Comparativo entre Periodos",
    descripcion:
      "El neto de cada empleado periodo por periodo, con la variación contra el anterior resaltada. Para cachar errores antes de timbrar.",
    icono: <LineChartOutlined />,
    color: "#FF6A1A",
    ruta: "comparativoPeriodos",
    disabled: false,
  },
  {
    key: "acumulados",
    titulo: "Acumulados por Empleado",
    descripcion:
      "Los acumulados del ejercicio por empleado y por tipo de acumulado, con corte opcional por rango de meses.",
    icono: <FundOutlined />,
    color: "#389E0D",
    ruta: "acumulados",
    disabled: false,
  },
  {
    key: "repse",
    titulo: "REPSE",
    descripcion:
      "Plantilla de subcontratación de servicios especializados: contratos y trabajadores del periodo, con sus días pagados.",
    icono: <SafetyCertificateOutlined />,
    color: "#5A4FCC",
    ruta: "repse",
    disabled: false,
  },
  {
    key: "xmlEmitidos",
    titulo: "XML Emitidos",
    descripcion:
      "CFDI de nómina timbrados en el periodo, con su UUID y estatus, más el catálogo completo de empleados.",
    icono: <FileProtectOutlined />,
    color: "#1677FF",
    ruta: "xmlEmitidos",
    disabled: false,
  },
  {
    key: "layoutEmpleados",
    titulo: "Layout de Empleados",
    descripcion:
      "El padrón de trabajadores del mes en el layout del cliente: RFC, nombre y el rango de fechas en que cada uno estuvo activo.",
    icono: <IdcardOutlined />,
    color: "#C41D7F",
    ruta: "layoutEmpleados",
    disabled: false,
  },
  {
    key: "personal",
    titulo: "Personal",
    descripcion:
      "El personal que estuvo dentro de la planta en el periodo, sacado de las nóminas timbradas, en el layout del cliente.",
    icono: <TeamOutlined />,
    color: "#D48806",
    ruta: "personal",
    disabled: false,
  },
  {
    key: "percepcionesPorPeriodo",
    titulo: "Percepciones por Periodo",
    descripcion:
      "Matriz de empleados contra periodos: en cada celda el total de percepciones que recibió el empleado, con su total y promedio del rango.",
    icono: <DollarOutlined />,
    color: "#08979C",
    ruta: "percepcionesPorPeriodo",
    disabled: false,
  },
  {
    key: "incidencias",
    titulo: "Incidencias",
    descripcion:
      "Faltas, permisos, incapacidades, vacaciones, retardos y horas extra por empleado. Se puede ver general del periodo, por nómina, o como rejilla día por día.",
    icono: <CalendarOutlined />,
    color: "#A8071A",
    ruta: "incidencias",
    disabled: false,
  },
];

class ReportesNomina extends Component {
  atras() {
    this.props.history.goBack();
  }

  seleccionar(opcion) {
    if (opcion.disabled) return;
    this.props.history.push(`${this.props.match.url}/${opcion.ruta}`);
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Reportes de Nómina"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        {/* Con más de 3 tarjetas la reja pasa a dos renglones: el marginBottom del
            Col evita que los renglones se peguen entre sí. */}
        <Row gutter={16}>
          {OPCIONES.map((opcion) => (
            <Col span={8} key={opcion.key} style={{ marginBottom: 16 }}>
              <Card
                hoverable={!opcion.disabled}
                onClick={() => this.seleccionar(opcion)}
                style={{
                  textAlign: "center",
                  height: 220,
                  opacity: opcion.disabled ? 0.55 : 1,
                  cursor: opcion.disabled ? "not-allowed" : "pointer",
                  borderTop: `3px solid ${opcion.color}`,
                  boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                }}
                bodyStyle={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <div style={{ fontSize: 36, color: opcion.color, marginBottom: 10 }}>
                  {opcion.icono}
                </div>
                <h2 style={{ fontSize: 16, marginBottom: 6 }}>{opcion.titulo}</h2>
                <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
                  {opcion.descripcion}
                </p>
              </Card>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}

export default ReportesNomina;
